import { TextField, UncontrolledTextField } from "./TextField";

export const NumberField = ({ ...props }: React.ComponentProps<typeof TextField>) => {
    return <TextField {...props} type="number" />;
};
export const UncontrolledNumberField = ({ ...props }: React.ComponentProps<typeof UncontrolledTextField>) => {
    return <UncontrolledTextField {...props} type="number" />;
};
